import { render, staticRenderFns } from "./Ustensiles.vue?vue&type=template&id=18e87b8e&scoped=true"
import script from "./Ustensiles.vue?vue&type=script&lang=js"
export * from "./Ustensiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e87b8e",
  null
  
)

export default component.exports